import type React from "react";

import {
  Popover as ShadcnPopover,
  PopoverAnchor as ShadcnPopoverAnchor,
  PopoverContent as ShadcnPopoverContent,
  PopoverDescription as ShadcnPopoverDescription,
  PopoverHeader as ShadcnPopoverHeader,
  PopoverTitle as ShadcnPopoverTitle,
  PopoverTrigger as ShadcnPopoverTrigger,
} from "src/shadcn/components/popover";

const Popover = (props: React.ComponentProps<typeof ShadcnPopover>) => (
  <ShadcnPopover {...props} />
);

const PopoverAnchor = (
  props: React.ComponentProps<typeof ShadcnPopoverAnchor>
) => <ShadcnPopoverAnchor {...props} />;

const PopoverContent = (
  props: React.ComponentProps<typeof ShadcnPopoverContent>
) => <ShadcnPopoverContent {...props} />;

const PopoverDescription = (
  props: React.ComponentProps<typeof ShadcnPopoverDescription>
) => <ShadcnPopoverDescription {...props} />;

const PopoverHeader = (
  props: React.ComponentProps<typeof ShadcnPopoverHeader>
) => <ShadcnPopoverHeader {...props} />;

const PopoverTitle = (
  props: React.ComponentProps<typeof ShadcnPopoverTitle>
) => <ShadcnPopoverTitle {...props} />;

const PopoverTrigger = (
  props: React.ComponentProps<typeof ShadcnPopoverTrigger>
) => <ShadcnPopoverTrigger {...props} />;

export {
  Popover,
  PopoverAnchor,
  PopoverContent,
  PopoverDescription,
  PopoverHeader,
  PopoverTitle,
  PopoverTrigger,
};
